import { Currencies, Money } from 'ts-money';
import { number, NumberSchema } from 'yup';

export const EuroValueSigned: NumberSchema = number().test(
  'euro-value',
  'Invalid euro decimal input',
  (value) => {
    if (value === undefined) return true;
    try {
      Money.fromDecimal(value, Currencies.EUR);
      return true;
    } catch {
      return false;
    }
  },
);

export const EuroValue: NumberSchema = EuroValueSigned.min(0.0, 'no_negative_value');
